import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/discovery';

const namespace = 'DISCOVERY';

export const FETCH_DISCOVERIES_START = `${namespace}/FETCH_DISCOVERIES_START`;
export const FETCH_DISCOVERIES_SUCCESS = `${namespace}/FETCH_DISCOVERIES_SUCCESS`;
export const FETCH_DISCOVERIES_ERROR = `${namespace}/FETCH_DISCOVERIES_ERROR`;

export const fetchDiscoveries = makeApiActionCreatorV3(
  api.fetchDiscoveries,
  FETCH_DISCOVERIES_START,
  FETCH_DISCOVERIES_SUCCESS,
  FETCH_DISCOVERIES_ERROR,
);

export const FETCH_DISCOVERY_START = `${namespace}/FETCH_DISCOVERY_START`;
export const FETCH_DISCOVERY_SUCCESS = `${namespace}/FETCH_DISCOVERY_SUCCESS`;
export const FETCH_DISCOVERY_ERROR = `${namespace}/FETCH_DISCOVERY_ERROR`;

export const fetchDiscovery = makeApiActionCreatorV3(
  api.fetchDiscovery,
  FETCH_DISCOVERY_START,
  FETCH_DISCOVERY_SUCCESS,
  FETCH_DISCOVERY_ERROR,
);

export const FETCH_DISCOVERY_FILES_START = `${namespace}/FETCH_DISCOVERY_FILES_START`;
export const FETCH_DISCOVERY_FILES_SUCCESS = `${namespace}/FETCH_DISCOVERY_FILES_SUCCESS`;
export const FETCH_DISCOVERY_FILES_ERROR = `${namespace}/FETCH_DISCOVERY_FILES_ERROR`;

export const fetchDiscoveryFiles = makeApiActionCreatorV3(
  api.fetchDiscoveryFiles,
  FETCH_DISCOVERY_FILES_START,
  FETCH_DISCOVERY_FILES_SUCCESS,
  FETCH_DISCOVERY_FILES_ERROR,
);

export const FETCH_CODEFILE_DISCOVERY_STATUS_START = `${namespace}/ FETCH_CODEFILE_DISCOVERY_STATUS_START`;
export const FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS = `${namespace}/FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS`;
export const FETCH_CODEFILE_DISCOVERY_STATUS_ERROR = `${namespace}/FETCH_CODEFILE_DISCOVERY_STATUS_ERROR`;

export const fetchCodefileDiscoveryStatus = makeApiActionCreatorV3(
  api.fetchCodefileDiscoveryStatus,
  FETCH_CODEFILE_DISCOVERY_STATUS_START,
  FETCH_CODEFILE_DISCOVERY_STATUS_SUCCESS,
  FETCH_CODEFILE_DISCOVERY_STATUS_ERROR,
);

export const FETCH_CODEFILE_FILING_PARTY_START = `${namespace}/FETCH_CODEFILE_FILING_PARTY_START`;
export const FETCH_CODEFILE_FILING_PARTY_SUCCESS = `${namespace}/FETCH_CODEFILE_FILING_PARTY_SUCCESS`;
export const FETCH_CODEFILE_FILING_PARTY_ERROR = `${namespace}/FETCH_CODEFILE_FILING_PARTY_ERROR`;

export const fetchCodefileFilingParty = makeApiActionCreatorV3(
  api.fetchCodefileFilingParty,
  FETCH_CODEFILE_FILING_PARTY_START,
  FETCH_CODEFILE_FILING_PARTY_SUCCESS,
  FETCH_CODEFILE_FILING_PARTY_ERROR,
);

export const INSERT_DISCOVERY_START = `${namespace}/INSERT_DISCOVERY_START`;
export const INSERT_DISCOVERY_SUCCESS = `${namespace}/INSERT_DISCOVERY_SUCCESS`;
export const INSERT_DISCOVERY_ERROR = `${namespace}/INSERT_DISCOVERY_ERROR`;

export const insertDiscovery = makeApiActionCreatorV3(
  api.insertDiscovery,
  INSERT_DISCOVERY_START,
  INSERT_DISCOVERY_SUCCESS,
  INSERT_DISCOVERY_ERROR,
);

export const INSERT_DISCOVERY_FILE_START = `${namespace}/INSERT_DISCOVERY_FILE_START`;
export const INSERT_DISCOVERY_FILE_SUCCESS = `${namespace}/INSERT_DISCOVERY_FILE_SUCCESS`;
export const INSERT_DISCOVERY_FILE_ERROR = `${namespace}/INSERT_DISCOVERY_FILE_ERROR`;

export const insertDiscoveryFile = makeApiActionCreatorV3(
  api.insertDiscoveryFile,
  INSERT_DISCOVERY_FILE_START,
  INSERT_DISCOVERY_FILE_SUCCESS,
  INSERT_DISCOVERY_FILE_ERROR,
);

export const UPDATE_DISCOVERY_START = `${namespace}/UPDATE_DISCOVERY_START`;
export const UPDATE_DISCOVERY_SUCCESS = `${namespace}/UPDATE_DISCOVERY_SUCCESS`;
export const UPDATE_DISCOVERY_ERROR = `${namespace}/UPDATE_DISCOVERY_ERROR`;

export const updateDiscovery = makeApiActionCreatorV3(
  api.updateDiscovery,
  UPDATE_DISCOVERY_START,
  UPDATE_DISCOVERY_SUCCESS,
  UPDATE_DISCOVERY_ERROR,
);

export const UPDATE_DISCOVERY_TAGS_START = `${namespace}/UPDATE_DISCOVERY_TAGS_START`;
export const UPDATE_DISCOVERY_TAGS_SUCCESS = `${namespace}/UPDATE_DISCOVERY_TAGS_SUCCESS`;
export const UPDATE_DISCOVERY_TAGS_ERROR = `${namespace}/UPDATE_DISCOVERY_TAGS_ERROR`;

export const updateDiscoveryTags = makeApiActionCreatorV3(
  api.updateDiscoveryTags,
  UPDATE_DISCOVERY_TAGS_START,
  UPDATE_DISCOVERY_TAGS_SUCCESS,
  UPDATE_DISCOVERY_TAGS_ERROR,
);

export const UPDATE_DISCOVERY_FILE_START = `${namespace}/UPDATE_DISCOVERY_FILE_START`;
export const UPDATE_DISCOVERY_FILE_SUCCESS = `${namespace}/UPDATE_DISCOVERY_FILE_SUCCESS`;
export const UPDATE_DISCOVERY_FILE_ERROR = `${namespace}/UPDATE_DISCOVERY_FILE_ERROR`;

export const updateDiscoveryFile = makeApiActionCreatorV3(
  api.updateDiscoveryFile,
  UPDATE_DISCOVERY_FILE_START,
  UPDATE_DISCOVERY_FILE_SUCCESS,
  UPDATE_DISCOVERY_FILE_ERROR,
);

export const DELETE_DISCOVERY_START = `${namespace}/DELETE_DISCOVERY_START`;
export const DELETE_DISCOVERY_SUCCESS = `${namespace}/DELETE_DISCOVERY_SUCCESS`;
export const DELETE_DISCOVERY_ERROR = `${namespace}/DELETE_DISCOVERY_ERROR`;

export const deleteDiscovery = makeApiActionCreatorV3(
  api.deleteDiscovery,
  DELETE_DISCOVERY_START,
  DELETE_DISCOVERY_SUCCESS,
  DELETE_DISCOVERY_ERROR,
);

export const DELETE_DISCOVERY_FILE_START = `${namespace}/DELETE_DISCOVERY_FILE_START`;
export const DELETE_DISCOVERY_FILE_SUCCESS = `${namespace}/DELETE_DISCOVERY_FILE_SUCCESS`;
export const DELETE_DISCOVERY_FILE_ERROR = `${namespace}/DELETE_DISCOVERY_FILE_ERROR`;

export const deleteDiscoveryFile = makeApiActionCreatorV3(
  api.deleteDiscoveryFile,
  DELETE_DISCOVERY_FILE_START,
  DELETE_DISCOVERY_FILE_SUCCESS,
  DELETE_DISCOVERY_FILE_ERROR,
);

export const DOWNLOAD_DISCOVERY_FILE_START = `${namespace}/DOWNLOAD_DISCOVERY_FILE_START`;
export const DOWNLOAD_DISCOVERY_FILE_SUCCESS = `${namespace}/DOWNLOAD_DISCOVERY_FILE_SUCCESS`;
export const DOWNLOAD_DISCOVERY_FILE_ERROR = `${namespace}/DOWNLOAD_DISCOVERY_FILE_ERROR`;

export const downloadDiscoveryFile = makeApiActionCreatorV3(
  api.downloadDiscoveryFile,
  DOWNLOAD_DISCOVERY_FILE_START,
  DOWNLOAD_DISCOVERY_FILE_SUCCESS,
  DOWNLOAD_DISCOVERY_FILE_ERROR,
);

export const FETCH_CODEFILE_DISCOVERY_TYPE_START = `${namespace}/FETCH_CODEFILE_DISCOVERY_TYPE_START`;
export const FETCH_CODEFILE_DISCOVERY_TYPE_SUCCESS = `${namespace}/FETCH_CODEFILE_DISCOVERY_TYPE_SUCCESS`;
export const FETCH_CODEFILE_DISCOVERY_TYPE_ERROR = `${namespace}/FETCH_CODEFILE_DISCOVERY_TYPE_ERROR`;

export const fetchCodefileDiscoveryType = makeApiActionCreatorV3(
  api.fetchCodefileDiscoveryType,
  FETCH_CODEFILE_DISCOVERY_TYPE_START,
  FETCH_CODEFILE_DISCOVERY_TYPE_SUCCESS,
  FETCH_CODEFILE_DISCOVERY_TYPE_ERROR,
);
